import { type RouteObject } from 'react-router';
import { ROUTES } from '@/shared/routing';

/**
 * 강제 업데이트 화면 (`/update-required`) — `/auth` 와 **같은 최상위 레벨**. 앱 본체(`createAppRoute`) 아래
 * 두지 않는 이유는 하위호환이 끊긴 구버전이 본체 가드·데이터 규약을 신뢰할 수 없기 때문이다.
 *
 * **layout 을 씌우지 않는다** — 다른 라우트가 쓰는 `standaloneLayout` 은 헤더·푸터(로그아웃·약관)를 달고
 * 오는데, 되돌아갈 길이 없어야 하는 화면에 로그아웃·약관 진입점이 있으면 안 된다. 화면 셸(safe-area)은
 * 페이지가 직접 소유한다. `RootLayout` 아래인 건 유지 — 거기서 native splash fade-out(`setAppReady`)과
 * 테마 배선이 일어나므로 벗어나면 WebView 가 splash 에서 멈춘다.
 *
 * **가드 없음(public) · 데이터 로드 없음** — 구버전 차단은 로그인 여부와 무관하고, 인증 규약 자체가 바뀐
 * 버전일 수도 있어 `requireAuth` 를 걸면 오히려 로그인 화면으로 튕겨 강제 업데이트가 무력화된다. loader 도
 * 두지 않아 이 화면에서는 어떤 API 도 나가지 않는다.
 *
 * 도달은 `widgets/version-update-gate` 가 native + `update-required` 판정 시 `replace` 로 보내고, 이탈도
 * 같은 게이트가 소유한다 — 판정이 `update-required` 를 벗어나면 본체로 다시 `replace`(라우트·페이지는 자기
 * 상태를 재검사하지 않는다).
 */
export function createUpdateRequiredRoute(): RouteObject {
  return {
    path: ROUTES.UPDATE_REQUIRED,
    lazy: {
      Component: () => import('@/pages/update-required').then((m) => m.UpdateRequiredPage),
    },
  };
}
